<template>
  <v-card flat>
    <div v-for="q in qualificationTimes.educations" :key="q.id">
      <v-expansion-panels class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header expand-icon="$sl-arrow-down">
            <v-row>
              <v-col cols="12" class="mb-n12" style="z-index: 100">
                <div class="d-flex">
                  <div class="d-flex">
                    <p class="header" v-if="q.professionId">
                      {{ getProfessionById(q.professionId).name }}
                    </p>
                    <span class="body-2 ml-4 mt-1" v-if="isCancelled(q.qualificationTime)">
                      Kvalificeringstid stoppad pga bortkopplad från företaget {{ get(q, 'qualificationTime.isAbortedDate', '') | date }}
                    </span>

                    <span class="body-2 ml-4 mt-1" v-else-if="printPauseDateString(q)">
                      {{ printPauseDateString(q) }}
                    </span>

                    <span class="body-2 ml-4 mt-1" v-else-if="get(q, 'qualificationTime.toDate', null)">
                      Aktiv kvalificeringstid förväntad färdig
                      {{ q.qualificationTime.toDate | date }} (id: {{ q.id }}{{ printApplicationId(q) }})
                    </span>
                  </div>
                  <div class="ml-auto" v-if="q.apprenticeships && q.apprenticeships.length > 0">
                    <p class="caption mr-4 mt-2">
                      Påbörjad {{ q.qualificationTime.fromDate | date }} hos
                      <router-link @click.stop="" :to="'/companies/' + get(currentQt(q.apprenticeships)[0], 'company.id', '')">
                        {{ get(currentQt(q.apprenticeships)[0], 'company.name', '') }}</router-link
                      >
                    </p>
                  </div>
                </div>
              </v-col>
              <v-col cols="12">
                <progressLinear
                  :value="progressValue(q.qualificationTime.fromDate, q.qualificationTime.toDate, q)"
                ></progressLinear>

                <!-- getPercentage(element.numSubElementsFinished, element.numSubElementsRequired) -->
                <p class="caption-1 mt-n4">Mätaren visar andel förlupen tid mellan start och förväntat slutdatum.</p>
              </v-col>
            </v-row>
          </v-expansion-panel-header>

          <v-expansion-panel-content>
          <v-row>
            <v-col cols="12" class="px-10 text-right">
              <v-btn v-if="isAdmin" class="mr-4" outlined @click="deleteQualificationTime(q)"> <v-icon>$sl-delete</v-icon>Radera</v-btn>
            </v-col>
          </v-row>
            <v-row class="mt-n5">
              <v-col sm="12" md="6">
                <div class="overline small">TYP AV KVALIFICERING</div>
                <div class="mb-6">
                  <p
                    class="mt-1 mb-0"
                    v-if="
                      q.qualificationTime &&
                      q.qualificationTime.qualificationTimeType &&
                      q.qualificationTime.qualificationTimeType.name
                    "
                  >
                    {{ q.qualificationTime.qualificationTimeType.name }}
                    <span>({{ get(q, 'qualificationTimeLength', 0) }} månader)</span>
                  </p>

                  <p v-if="adjustedLengthInMonths(q)">
                    Justerad kvalificeringstid
                    <span>
                      ({{ adjustedLengthInMonths(q) }} månader)
                    </span>
                  </p>
                </div>
              </v-col>
              <v-col sm="12" md="6" class="mb-8" v-if="certificates && certificates.length > 0">
                <template v-if="isSameProfession(q)">
                  <div class="overline small">YRKESBEVIS SOM PERSONEN REDAN HAR</div>
  
                  <ul class="ml-4" v-for="(c, index) in certificates" :key="index">
                    <li v-if="c.profession && c.profession.name">
                      {{ c.profession.name }}
                    </li>
                  </ul>
                </template>
              </v-col>
            </v-row>

            <div class="mt-n5">
              <div class="d-flex">
                <!-- <div class="overline small">KVALIFICERINGSTIDENS LÄNGD</div> -->
                <!-- <div class="caption small ml-5">
                  <a
                    href="https://www.byggbranschensyrkesnamnd.se/om-byn/yrkesutbildningsavtal/yua-2020-avtal-och-anvisningar/"
                    target="blank"
                    ><v-icon class="special-icon-size mr-1">$sl-question-circle</v-icon>Så här beräknas
                    kvalificeringstid</a
                  >
                </div> -->
                
              </div>
              <template v-if="isCancelled(q.qualificationTime)">
                Kvalificeringstid stoppad
              </template>
              <template v-else>
                <p>Återstående kvalificeringstid {{ getQtimeLength(q.qualificationTime.fromDate, q.qualificationTime.toDate, dateRange(q.qualificationTime.fromDate, q.qualificationTime.toDate), 'medium') }}</p>
              </template>
              <template v-if="hasProfessionOrientations(q.professionId)">
                <v-btn color="secondary" class="icon" @click="selectedEducation= q, createCardModal = true" :disabled="!canCreate">
                  <v-icon>$sl-invitation</v-icon>BESTÄLL MASKINKORT
                </v-btn>
                <div>
                  <p class="small-text small mt-2"><a @click="showHistory = true">Visa beställningshistorik</a></p>
                </div>
              </template>
            </div>

            <h6 class="text-uppercase mt-8">Arbetsgivare</h6>

            <div class="mt-4" v-for="(a, index) in sortedEmployments(q.apprenticeships)" :key="index">
              <p class="grey-text">
                <v-icon class="mt-n3 mr-1">$sl-ikon-building</v-icon
                ><router-link :to="'/companies/' + a.companyId">{{ a.company.name }}</router-link>
                <span class="small-text"> ({{ a.fromDate | date }} — {{ a.toDate | date }}) </span>
              </p>
              <div class="ml-2">
                <div class="mt-n2 overline small">ORGANISATIONSNUMMER</div>
                <p>
                  {{ a.company.organizationalNumber.slice(0, 6) + '-' + a.company.organizationalNumber.slice(6, 10) }}
                </p>
                <div class="mt-n3 overline small">ANSTÄLLNINGSFORM</div>
                <p>
                  {{ a.employmentType.name }}
                </p>

                <div v-for="i in a.apprenticeshipInstructors" :key="i.id">
                  <div class="mt-5 overline small">HANDLEDARE</div>
                  <router-link
                    v-if="get(i, 'instructor.employed.id', null)"
                    :to="'/people/' + get(i, 'instructor.employed.id', -1)"
                  >
                    <p class="mb-0">
                      {{ get(i, 'instructor.employed', '') | fullName }}
                    </p>
                  </router-link>
                  <ul>
                    <li>
                      Yrkesbevis
                      {{ sepArrayByComma(get(i, 'instructor.employed.tradeCertificates', [])) }}
                    </li>
                    <li>
                      Handledardispens
                      {{ sepArrayByComma(get(i, 'instructor.employed.instructorExemptions', [])) }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <template>
              <h6 class="text-uppercase mt-12">Händelser</h6>
              <v-timeline dense align-top class="ml-n8">
                <v-timeline-item v-for="(item, index) of timelineitems(q)" :key="index" class="events" small>
                  <v-row class="ml-n6 pl-6 mt-n2 pt-2 hoverable-body">
                    <v-col class="pl-0 pt-0"  cols="10">
                      <div>{{ item.text }}</div>
                    </v-col>
                    <v-col class="pt-0">
                      <strong>{{ item.createdAt | date }}</strong> {{ item.createdAt | time }}
                    </v-col>
                  </v-row>
                </v-timeline-item>
              </v-timeline>
            </template>

            <template>
              <h6 class="text-uppercase mt-12">UPPEHÅLL</h6>
              <v-data-table :headers="headers" :items="pausedQTMS(q)" item-key="id" class="mt-6">
                <template slot="item.fromDate" slot-scope="props">
                  <div>{{ props.item.startDate | date }}</div>
                </template>
                <template slot="item.toDate" slot-scope="props">
                  <div v-if="props.item.endDate">{{ props.item.endDate | date }}</div>
                  <div v-else>Obestämt</div>
                </template>
                <template slot="item.days" slot-scope="props">
                  <div v-if="props.item.endDate">{{ (dateRange(props.item.startDate, props.item.endDate) / 365) * 365 }} dagar</div>
                  <div v-else>Obestämt</div>
                </template>
                <template slot="item.createdById" slot-scope="props">
                  <div>{{ props.item.createdBy | fullName }}</div>
                </template>
                <template slot="item.status" slot-scope="props">
                  <div :style="{ lineHeight: '48px' }">{{ getStatus(props.item) }}</div>
                </template>

                <template slot="item.action" slot-scope="props">
                  <div :style="{ lineHeight: '48px' }">
                    <v-icon
                      class="clickable"
                      @click="
                        qualificationTimeModification = props.item
                        qualificationViewModal = true
                      "
                      >$sl-view-on</v-icon
                    >
                  </div>
                </template>
              </v-data-table>
              <p class="caption-1 mt-n8">Längdangivelsen anger antalet dagar inklusive slutdatum. Avbrutna kvalificeringstider räknas som uppehåll på obestämd tid. Uppehåll raderas automatiskt av systemet fem år efter angivet startdatum.</p>
            </template>

            <v-card-actions class="no-margins mt-12 mb-2">
              <v-btn color="primary"
                class="icon"
                @click="approveQtModal = true"
                v-if="isApproveQtButtonVisible(q.qualificationTime)"
                :disabled="disableApprovedButton(q.qualificationTime) || !canUpdate"
              >
                <v-icon>$sl-like</v-icon>GODKÄNN KVALIFICERINGSTID
              </v-btn>
              <v-btn color="secondary"
                class="icon" 
                @click="changeModal = true; qualificationTime = q.qualificationTime"
                :disabled="isQualificationTimeAborted(q.qualificationTime) || isSameQmtIssuer(q.qualificationTime) || !canUpdate || actionIsDisabledForUser(get(q, 'regionId', null))" 
              >
                <v-icon>$sl-edit</v-icon>ÄNDRA KVALIFICERINGSTID
              </v-btn>
              <v-btn color="secondary"
                class="icon"
                @click="qualificationTime = q.qualificationTime; pauseQtime()"
                :disabled="isQualificationTimeAborted(q.qualificationTime) || isSameQmtIssuer(q.qualificationTime) || !canUpdate || actionIsDisabledForUser(get(q, 'regionId', null))" 
              >
                <v-icon>$sl-pause-qtime</v-icon>AVBRYT KVALIFICERINGSTID
              </v-btn>
            </v-card-actions>
            <h6 class="text-uppercase mt-8">Ändringar i sysselsättningsgrad</h6>
            <v-data-table :headers="employmentRateHeaders" :items="employmentRateModifications[q.id]" item-key="id" class="mt-6">
              <template slot="item.startDate" slot-scope="props">
                <div>{{ props.item.startDate }}</div>
              </template>
              <template slot="item.endDate" slot-scope="props">
                <div>{{ props.item.endDate }}</div>
              </template>
              <template slot="item.employmentRate" slot-scope="props">
                <div>{{ props.item.employmentRate }}</div>
              </template>
              <template slot="item.createdBy" slot-scope="props">
                <div>{{ props.item.createdBy }}</div>
              </template>
            </v-data-table>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-dialog v-model="changeModal" max-width="600px">
        <ChangeTimeModal :propProfessionId="q.professionId" :propQualificationTime="qualificationTime" @close="changeModal = false; init();" />
      </v-dialog>
    </div>

    <v-dialog v-model="qualificationViewModal" max-width="600px">
      <QualificationViewModal :qtm="qualificationTimeModification" @close="qualificationViewModal = false" />
    </v-dialog>
    <v-dialog v-model="showHistory" max-width="600px">
      <showHistory @close="showHistory = false" :showModal="showHistory" />
    </v-dialog>
    <v-dialog v-model="createCardModal" max-width="600px">
      <CreateShowCard mode="create" :education="selectedEducation" @close="createCardModal = false" />
    </v-dialog>

    <v-dialog v-model="approveQtModal" :max-width="720">
      <QualificationTimeModal
        :QTM="qtObj"
        @close="
          approveQtModal = false
          getQualificationTime()
        "
      />
    </v-dialog>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {mapGetters, mapActions} from 'vuex'
import progressLinear from '@/components/common/ProgressLinear'
import QualificationViewModal from '@/components/person/qualificationtime/QualificationViewModal'
import ChangeTimeModal from '@/components/person/qualificationtime/ChangeTimeModal'
import showHistory from '@/components/person/MachineCard/showHistory'
import CreateShowCard from '@/components/person/MachineCard/CreateShowCard'
import sortBy from 'lodash/sortBy'
import filter from 'lodash/filter'
import find from 'lodash/find'
import get from 'lodash/get'
import {Utilities, UserRules, CanIDo} from '@/components/mixins'
import QualificationTimeModal from "@/components/person/qualificationtime/qualificationTimeModal"
import { orderBy, some } from 'lodash'
const SugarDate = require("sugar/date");

export default {
  name: 'PersonQualificationTime',
  mixins: [Utilities, UserRules, CanIDo],
  components: {
    progressLinear,
    QualificationViewModal,
    showHistory,
    CreateShowCard,
    ChangeTimeModal,
    QualificationTimeModal
  },
  data() {
    return {
      selectedEducation: {},
      qualificationTime: {},
      qualificationTimes: {},
      qualificationTimeModification: {},
      qualificationViewModal: false,
      changeModal: false,
      showHistory: false,
      createCardModal: false,
      employmentRateModifications: {},
      approveQtModal: false,
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.init()
      },
      deep: true,
      immediate: true
    },
  },

  created() {
    this.init()
  },
  computed: {
    ...mapGetters('app', ['isLoading']),
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('basic', ['getProfessionById','hasProfessionOrientations', 'getRegionById']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole']),

    isQualificationTimeAborted() {
      return qt => !!qt.isAbortedDate
    },

    isAdmin() {
      return this.currentUserRole === 'admin'
    },

    qtObj() {
      let prop
      this.qualificationTimes?.educations?.forEach(edu => {
        let state
      
        if (edu.qualificationTime.approvedBySecondaryId > 0)
          state = "Godkänd"
        else if (edu.qualificationTime.approvedById > 0 && this.currentUser.id == edu.qualificationTime.approvedById)
          state = "Väntar på godkännande av annan regionär"
        else state = "Väntar på godk."

        prop = { 
          id: edu.qualificationTime.id,
          name: 'Kvalificeringstid',
          regionId: edu.regionId,
          qualificationTimeFromDate: edu.qualificationTime.fromDate,
          qualificationTimeToDate: edu.qualificationTime.toDate,
          state: state,
          actions: "approveQualificationTimeModal",
          isApproved: edu.qualificationTime.isApproved,
          approvedAt: edu.qualificationTime.approvedAt,
          approvedById: edu.qualificationTime.approvedById,
          approvedBySecondaryId: edu.qualificationTime.approvedBySecondaryId,
          fromDate: edu.qualificationTime.fromDate,
          date: edu.qualificationTime.fromDate,
          approvedAtSecondary: new Date(),
          toDate: edu.qualificationTime.toDate,
          approvedBySecondary: edu.qualificationTime.approvedBySecondary,
          approvedBy: edu.qualificationTime.approvedBy,
          updatedAt: edu.qualificationTime.updatedAt,
          educationId: edu?.id
        }
      })

      return prop
    },

    disableApprovedButton() {
      return qT => qT.approvedById === this.currentUser.id
    },

    disableButton() {
      return qT => qT.isApproved
    },

    isSameQmtIssuer() {
      return qt => qt.qualificationTimeModifications.some(qmt => qmt.approvedById === this.currentUser.id && !qmt.approvedBySecondaryId)
    },

    headers() {
      return [
        {text: 'FR.O.M.', value: 'fromDate', width: '160'},
        {text: 'T.O.M.', value: 'toDate', width: '160'},
        {text: 'LÄNGD', value: 'days', width: '520'},
        {text: 'ANSÖKAN GJORD AV', value: 'createdById', width: '240'},
        {text: 'MOTIVERING', value: 'reason', width: '240'},
        {
          text: 'STATUS',
          value: 'status',
          align: 'center',
          sortable: false,
          width: '100'
        },
        {text: 'Visa', value: 'action', align: 'center', sortable: false, width: '120'}
      ]
    },

    employmentRateHeaders() {
      return [
        {text: 'Startdatum', sortable: false, filterable: false, value: 'startDate', width: '160'},
        {text: 'Slutdatum', sortable: false, filterable: false, value: 'endDate', width: '160'},
        {text: 'Sysselsättningsgrad', sortable: false, filterable: false, value: 'employmentRate', width: '80'},
        {text: 'Skapad av', sortable: false, filterable: false, value: 'createdBy', width: '240' }
      ]
    },

    QTMBreak() {
      return q => {
        const QTMBreak = find(get(q, 'qualificationTime.qualificationTimeModifications', []), ['toDate', null])
        if (QTMBreak) {
          return {
            approvedBy: QTMBreak.approvedBy,
            approvedById: QTMBreak.approvedById,
            approvedBySecondary: QTMBreak.approvedBySecondary,
            approvedBySecondaryId: QTMBreak.approvedBySecondaryId,
            bookId: 0,
            createdBy: QTMBreak.createdBy,
            createdById: QTMBreak.createdById,
            educationId: null,
            employmentRate: 0,
            fromDate: QTMBreak.fromDate,
            endDate: null,
            reason: 'Kvalificeringstiden avbruten',
            startDate: QTMBreak.fromDate
          }
        }
        return null
      }
    },

    certificates() {
      return this.qualificationTimes.tradeCertificates
    },

    isSameProfession() {
      return e => !!this.certificates.some(({ profession }) => profession.id === e.professionId)
    },

    sortedEmployments() {
      return employments => orderBy(employments, ['toDate'], ['desc'])
    }
  },

  asyncComputed: {
    canUpdate(){
      return this.canIDo('education', 'update');
    },
    canCreate(){
      return this.canIDo('education', 'create');
    }
  },

  methods: {
    get,
    sortBy: sortBy,

    printPauseDateString(qt = null) {
      if ( !qt )
        return null

      const pauses = this.pausedQTMS(qt)
      if ( !pauses.length )
        return null

      let pause = orderBy(filter(this.pausedQTMS(qt), function(o) { 
        return o.approvedById && o.approvedBySecondaryId && o.reason !== 'Ändring av sysselsättningsgrad'
      }), ['endDate'], ['desc'])[0]

      if ( new Date(get(pause, 'startDate', null)) > new Date() || new Date(get(pause, 'endDate', null)) < new Date() )
        return null
      
      return `Kvalificeringstiden är pausad 
        ${ new Date(pause.startDate).toISOString().split('T')[0] } - 
        ${ new Date(pause.endDate).toISOString().split('T')[0] 
      }`
    },

    printApplicationId(education = null) {
      let applicationId = null
      let placeholder = ', anmälan:'
      
      if ( !education ) return ', -'

      applicationId = (
        this.selectedPerson?.distanceOrders?.find(d => d.id === education.distanceOrderId)?.applicationId || 
        this.selectedPerson?.educations?.find(e => e.id === education.id)?.application?.id 
      )

      if ( !applicationId )
        applicationId = ', -'

      return `${ placeholder } ${ applicationId }`
    },
    
    isCancelled(qualificationTime) {
      if ( !qualificationTime )
        return false

      return !!Boolean(qualificationTime.isCancelled || qualificationTime.doAbort)
    },

    adjustedLengthInMonths(education = {}) {
      if ( !get(education, 'qualificationTime.qualificationTimeModifications', []).length ) 
        return null

      return get(education, 'qualificationTime.qualificationTimeModifications', []).reduce((acc, qmt) => {
        if ( qmt.lengthInMonths > get(education, 'qualificationTimeLength', 0) )
          qmt.lengthInMonths = qmt.lengthInMonths - get(education, 'qualificationTimeLength', 0)

        return acc + qmt.lengthInMonths
      }, 0)
    },

    currentQt(apprenticeships) {
      const activeApprenticeships = filter(apprenticeships, ['manuallyEndedDate', null])
      if(activeApprenticeships.length) {
        return activeApprenticeships
      } else {
        return this.sortCompanies(apprenticeships)
      } 
    },

    async deleteQualificationTime(education) {
      const res = await this.$dialog.confirm({
        title: 'VILL DU RADERA KVALIFICERINGSTIDEN?',
        text: 'Radering av kvalificeringstid går inte att ångra.',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true,  icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return
      
      const { id } = education.qualificationTime

      API.deleteQualificationTime(id).then( async () => {
        const { id } = education.apprenticeships.find(a => a.educationId === education.id)
        await this.deleteApprenticeship(id)

        this.$events.fire('showInfo', 'Kvalificeringstid raderad.')
        this.init()
      })
    },

    async deleteApprenticeship(id) {

      const res = await this.$dialog.confirm({
        title: 'Vill du även radera anställning kopplad till raderad kvalificeringstid?',
        text: 'Radering av anställning går inte att ångra.',
        width: 600,
        actions: [
          {text: 'Nej', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true,  icon: '$sl-delete', outlined: true}
        ]
      })

      if (res !== true) return

      if( !id ) {
        return this.$events.fire('showError', 'Hittar ingen anställning.')
      }

      API.deleteApprenticeship(id).then(() => {
        this.$events.fire('showInfo', 'Anställning raderad.')
      })
      .catch(error => {
        console.log('Error: ', error)
        this.$events.fire('showError', 'Tyvärr gick det inte att radera.')
      })
    },

    isApproveQtButtonVisible(qT) {
      return qT.isApprovedByInstructor && !qT.isApproved
    },

    init() {
      this.getQualificationTime()
    },

    async pauseQtime() {
      const res = await this.$dialog.confirm({
        title: 'AVBRYT KVALIFICERINGSTIDEN?',
        width: '700px',
        text: 'Denna funktion används endast om lärlingen med säkerhet inte kommer att återvända till branschen då det inte går att återuppta en avbruten kvalificeringstid. Om lärlingen slutat på företaget och eventuellt kommer att fortsätta sin kvalificeringstid i ett annat företag använd istället funktionen "Koppla bort". Avbrutna kvalificeringstider rensas bort automatiskt efter 5 år.',
        actions: [
          {text: 'Tillbaka', key: false, icon: '$sl-cancel'},
          {text: 'Avbryt Kvaliferingstiden', key: true,  icon: '$sl-pause-qtime', outlined: true}
        ]
      })

      if (res !== true) {
        return
      }

      let createObject = {
        doAbort: true,
        fromDate: new Date(),
        newLengthInMonths: -1,
        qualificationTimeId: this.qualificationTime.id
      }

      API.createQualificationTimeModification({data: createObject})
        .then(response => {
          this.init()
          this.$events.fire('showInfo', 'Skickad för godkännande.')
        })
        .catch(error => {
          console.log('Error: ', error)
          this.$events.fire('showError', 'Tyvärr gick det inte att spara.')
        })
    },

    getStatus(i) {
      if (i.approvedBySecondaryId) {
        return 'Beviljad'
      }
      if (i.rejectedById) {
        return 'Avslagen'
      }
    },

    getQualificationTime() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return
      API.getPersonQualificationTime(this.$route.params.id)
        .then(res => {
          this.qualificationTimes = res.data
          this.employmentRateModifications = {}

          this.qualificationTimes.educations.forEach(education => {
            this.employmentRateModifications[education.id] = []

            education.qualificationTimePauses.forEach(qtp => {
              if(qtp.employmentRate != 0.0) {
                this.employmentRateModifications
                this.employmentRateModifications[education.id].push({
                  id: qtp.id,
                  startDate: qtp.startDate ? new Date(qtp.startDate).toLocaleDateString() : '',
                  endDate: qtp.endDate ? new Date(qtp.endDate).toLocaleDateString() : '',
                  employmentRate: qtp.employmentRate ? (qtp.employmentRate * 100 + '%') : '0%',
                  createdBy: `${get(qtp, 'createdBy.firstName', '')} ${get(qtp, 'createdBy.lastName', '')}`
                })
              }
            })
          })

        })
        .catch(error => {
          console.log('get document error, ', error)
        })
    },
    sortCompanies(apprenticeships) {
      return sortBy(apprenticeships, [
        function (o) {
          return o.fromDate && o.manuallyEndedDate
        }
      ])
    },
    
    getQtimeLength(fromDate, toDate, incommingDays, format = ''){
      var ret
      var days = Math.floor((SugarDate.Date(fromDate).daysUntil(toDate)%365)%30)
      var months = Math.floor(SugarDate.Date(fromDate).daysUntil(toDate)/30)

     // var years = Math.floor(SugarDate.Date(fromDate).daysUntil(toDate)/365)
      var today = new Date()
      if(SugarDate.Date.isAfter(new Date(fromDate), new Date()))
        today=new Date(fromDate)
      var daysLeft = Math.floor((SugarDate.Date(today).daysUntil(toDate)%365)%30)
      var monthsLeft = Math.floor(SugarDate.Date(today).daysUntil(toDate)/30)
     // var yearsLeft = Math.floor(SugarDate.Date(today).daysUntil(toDate)/365)

      if(days==1)
        days = days + ' dag'
      else
        days = days + ' dagar'
      if(months==1)
        months = months + ' månad'
      else
        months = months + ' månader'

      if(daysLeft==1)
        daysLeft = daysLeft + ' dag'
      else if(daysLeft<1)
        daysLeft = '0 dagar'
      else
        daysLeft = daysLeft + ' dagar'
      if(monthsLeft==1)
        monthsLeft = monthsLeft + ' månad'
      else if(monthsLeft<1)
        monthsLeft = ''
      else
        monthsLeft = monthsLeft + ' månader'

      if ( format.includes('short') ) 
        ret = months
      else if ( format.includes('medium') )
        ret = monthsLeft + ' (' + daysLeft + ')'
      else ret = months + ' (' + days + '), varav ' + monthsLeft + ' (' + daysLeft + ') återstår'

      return ret
    },
    dateRange(fromDate, toDate) {
      // To set two dates to two variables
      var date1 = new Date(fromDate)
      var date2 = new Date(toDate)
      // To calculate the time difference of two dates
      var Difference_In_Time = date2.getTime() - date1.getTime()
      var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)

      return Difference_In_Days
    },

    progressValue(fromDate, toDate, education = {}) {
      var startDate = new Date(fromDate).getTime()
      var endDate = new Date(toDate).getTime()
      var todayDate = new Date().getTime()

      //- Modify parameters for when qualification time is cancelled
      if ( this.isCancelled(get(education, 'qualificationTime', null)) ) {
        const lastApprenticeship = find(get(education, 'apprenticeships', []), function(o) { return o.educationId === get(education, 'id', null) })
        todayDate = new Date(get(lastApprenticeship, 'toDate', null)).getTime()
        endDate = new Date(get(education, 'qualificationTime.toDate', null)).getTime()
      }

      // Get the total possible timestamp value
      var total = endDate - startDate

      // Get the current value
      var current = todayDate - startDate
      var percentage = (current / total) * 100

      // Get the percentage
      return this.getPercentage(current, total)
    },

    sepArrayByComma(tradeCertificates) {
      let ret = ''
      tradeCertificates.forEach(i => {
        if (ret != '') ret += ','
        ret += i.profession.name
      })
      return ret.replace(/\s*,\s*/g, ', ')
    },

    pausedQTMS(q) {
      let QTMBreak = this.QTMBreak(q)
      if (QTMBreak) {
        return q.qualificationTimePauses.concat([QTMBreak])
      }
      return q.qualificationTimePauses
    },

    timelineitems(q) {
      let items=[]
      items.push({ text: `Kvalificeringstid (id ${q.id}) inleddes.`, createdAt: get(q, 'qualificationTime.createdAt', null) })
      const mods=filter(get(q, 'qualificationTime.qualificationTimeModifications', []), ['approved', true])
      mods.forEach(m => {
        if (m.lengthInMonths) {
          items.push({ text: `${ get(m, 'createdBy.firstName', '') } ${ get(m, 'createdBy.lastName', '') } ändrade kvalificeringstiden (id ${q.id}) till ${Math.round(m.lengthInMonths)} månader (${this.$options.filters.date(m.fromDate)} - ${this.$options.filters.date(m.toDate)})${ (m.reason ? ', med motiveringen: '+m.reason : '') }`, createdAt: m.createdAt })
        } else {
          items.push({ text: `${ get(m, 'createdBy.firstName', '') } ${ get(m, 'createdBy.lastName', '') } avbröt kvalificeringstiden (id ${q.id})`, createdAt: m.createdAt })
        }
      })

      return items
    },

    actionIsDisabledForUser(regionId) {
      if ( !regionId ) return true
      
      const roleIsAdmin = get(this, 'currentUserRole', '') === 'admin'
      if ( roleIsAdmin ) return false
      
      const regionIds = get(this, 'currentUser.regionIds', [])
      if ( !regionIds.length ) return false
      
      return !get(this, 'currentUser.regionIds', []).includes(regionId)
    }
  },
}
</script>

<style lang="scss">

.hoverable-body:hover {
  background-color: rgba(53, 189, 214, 0.12);
}

.v-timeline-item.events {
  .v-timeline-item__divider {
    .v-timeline-item__dot {
      .v-timeline-item__inner-dot.primary {
        color: var(--v-primary-darken4) !important;
        background-color: var(--v-primary-darken4) !important;
      }
    }
  }
} 
</style>
